<div class="grid">
    <div class="col-12">
        <div class="card" *ngIf="!permissaoListar">
            <div style="text-align: center">
                <h4>Você não possui permissão de acesso essa página!</h4>
            </div>
        </div>
        <div class="card" *ngIf="permissaoListar">
            <div class="formgroup" *ngIf="permissaoInserir">
                <div class="p-fluid p-formgrid grid">
                    <div class="field col-12 md:col-2">
                        <button
                            pButton
                            pRipple
                            routerLink="/apps/cliente/inserir"
                            label="Novo"
                            icon="pi pi-plus"
                            class="p-button-outlined sm:w-9rem"
                        ></button>
                    </div>
                </div>
            </div>
            <div *ngIf="messagemVisivel" class="field col-12 md:col-12">
                <p-messages
                    [(value)]="messages"
                    [enableService]="false"
                    [closable]="true"
                ></p-messages>
            </div>
            <p-table
                #dt1
                [value]="clientes"
                dataKey="id"
                [rows]="itensPaginados ? itensPaginados.size : 0"
                [loading]="loadingTable"
                [rowHover]="true"
                [paginator]="true"
                (onLazyLoad)="onLazyLoad($event)"
                [totalRecords]="itensPaginados ? itensPaginados.totalElements : 0"
                [lazy]="true"
                [showCurrentPageReport]="true"
                responsiveLayout="stack"
                styleClass=" p-datatable-sm"
                currentPageReportTemplate="Mostrando {first} ao {last} de {totalRecords} registros"
            >
                <ng-template pTemplate="caption">
                    <div class="flex justify-content-between flex-column sm:flex-row">
                        <p-dropdown
                            class="p-fluid sm:mr-2"
                            [options]="situacoesStatus"
                            optionLabel="label"
                            optionValue="value"
                            emptyFilterMessage="Nenhum registro"
                            name="situacao"
                            ngModel
                            #situacao="ngModel"
                            [(ngModel)]="situacaoSelecionada"
                            (onChange)="listarClientes()"
                        ></p-dropdown>
                        <div class="p-fluid mt-2 sm:mt-0">
                            <div class="flex">
                                <span class="p-input-icon-left">
                                    <i class="pi pi-search"></i>
                                    <input
                                        pInputText
                                        type="text"
                                        #filter
                                        (input)="buscar($event)"
                                        placeholder="Buscar"
                                        class="w-full"
                                    />
                                </span>
                                <span class="ml-2">
                                    <button
                                        pButton
                                        class="p-button-outlined"
                                        icon="pi pi-filter-slash"
                                        pTooltip="Limpar Filtros"
                                        (click)="limpar()"
                                    ></button>
                                </span>
                            </div>
                        </div>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="nome">
                            Nome
                            <p-sortIcon field="nome"></p-sortIcon>
                        </th>
                        <th pSortableColumn="apelido">
                            Apelido
                            <p-sortIcon field="apelido"></p-sortIcon>
                        </th>
                        <th pSortableColumn="cidade">
                            Cidade
                            <p-sortIcon field="cidade"></p-sortIcon>
                        </th>
                        <th pSortableColumn="uf">
                            UF
                            <p-sortIcon field="uf"></p-sortIcon>
                        </th>
                        <th>Última visita</th>
                        <th>Status</th>
                        <th style="text-align: center">
                            <div>Ações</div>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-item>
                    <tr>
                        <td>
                            {{ item.nome }}
                        </td>
                        <td>
                            {{ item.apelido }}
                        </td>
                        <td>
                            {{ item.cidade }}
                        </td>
                        <td>
                            {{ item.uf }}
                        </td>
                        <td>
                            {{ item.ultimaComanda | date: "dd/MM/yyyy" }}
                        </td>
                        <td>
                            <span class="product-badge status-instock" *ngIf="item.status">
                                ATIVO
                            </span>
                            <span class="product-badge status-outofstock" *ngIf="!item.status">
                                INATIVO
                            </span>
                        </td>
                        <td style="text-align: center">
                            <div>
                                <button
                                    *ngIf="permissaoDetalhar"
                                    pButton
                                    pRipple
                                    pTooltip="Detalhar"
                                    (click)="
                                        redirecionarPagina('/apps/cliente/detalhar/' + item.id)
                                    "
                                    icon="pi pi-eye"
                                    class="p-button-info mr-2 mb-2"
                                ></button>
                                <button
                                    *ngIf="permissaoEditar"
                                    pButton
                                    pRipple
                                    pTooltip="Editar"
                                    (click)="redirecionarPagina('/apps/cliente/editar/' + item.id)"
                                    icon="pi pi-pencil"
                                    class="p-button-success mr-2 mb-2"
                                ></button>
                                <button
                                    *ngIf="permissaoExcluir"
                                    pButton
                                    pRipple
                                    pTooltip="Excluir"
                                    icon="pi pi-trash"
                                    (click)="excluirCliente(item.id)"
                                    class="p-button-danger mr-2 mb-2 sm"
                                ></button>
                            </div>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="7">Nenhum registro encontrado.</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="loadingbody">
                    <tr>
                        <td colspan="7">Carregando clientes. Por favor aguarde.</td>
                    </tr>
                </ng-template>
            </p-table>
            <p-confirmDialog [style]="{ width: '50vw' }"></p-confirmDialog>
        </div>
    </div>
</div>
